import { AfterContentInit, Directive, ElementRef, HostBinding, Input, Renderer2 } from '@angular/core';

@Directive({
    selector: '[pxHintRow]',
})
export class PxHintRowDirective implements AfterContentInit {
    @Input() pxHintRow: 'success' | 'warning' | 'error' | 'default' = 'default';
    @HostBinding('attr.id') id: string;

    constructor(private el: ElementRef, private renderer: Renderer2) {}

    ngAfterContentInit() {
        this.renderer.addClass(this.el.nativeElement, 'form-text');
        if (this.pxHintRow !== 'default') {
            this.renderer.addClass(this.el.nativeElement, `ba-${this.pxHintRow}`);
        }
        if (this.pxHintRow === 'error') {
            this.renderer.setAttribute(this.el.nativeElement, 'aria-live', 'polite');
        }
    }
}
